export default __webpack_public_path__ + "static/maisies-melody-878d137d8a81297f7512284ebe9f8f33.svg";